import React from 'react'

import Navbar from './Home/Navbar'
import Hero from './services/Hero'
import Footer from './Home/Footer'
// import FeaturedHero from './Home/FeaturedHero'
// import HowItWorks from './Home/HowItWorks'
// import KeyBenefits from './Home/KeyBenefits'
import Details from './services/Details'

export default function Services() {
  return (
   <div className='w-full overflow-hidden'>
    <div className=']   '> 
      
         <Navbar/>
         <Hero/>
    </div>
         <Details/>
         <Footer/>
       </div>
  )
}
